// This file was auto-generated by Fern from our API Definition.
const LicenseIdValues = {
    Mit: "MIT",
    Apache2: "Apache-2.0",
};
export const LicenseId = Object.assign(Object.assign({}, LicenseIdValues), { _visit: (value, visitor) => {
        switch (value) {
            case LicenseId.Mit:
                return visitor.mit();
            case LicenseId.Apache2:
                return visitor.apache2();
            default:
                return visitor._other();
        }
    } });
